import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
  labels: ['Hispanic', 'White',],
  datasets: [
    {
      label: '# of Votes',
      data: [12, 19,],
      backgroundColor: [
        '#FFD600',
        '#E0E0E0',
        
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
       
      ],
      borderWidth: 1,
    },
  ],
};

export default()=> {
  return <> 
    <div className='col-md-6'>
        <label className='fw-bold' htmlFor="">
            Ethnicities
        </label>
    <Doughnut data={data} />;
    </div>
        </>
}
